<script>
    import AssessmentNav from '../AssessmentNav.svelte';
    import SlideEditor from './AssessmentSlideEditor.svelte';
    import AssessmentExcelPreview from './AssessmentExcelPreview.svelte';
    import AssessmentReportSection from './AssessmentReportSection.svelte';

    export let assessment;
    export let assessment_model;
    export let params;
</script>

<div class="columns">
    <div class="column is-2">
        <AssessmentNav assessment_id={$assessment.details._id} />
        <h1 class="title is-1">
            {$assessment.details.name}
        </h1>
        <aside class="menu">
            <p class="menu-label">Report Sections</p>
            <ul class="menu-list">
                {#each $assessment.assessment_type_data.report_sections as section}
                    <li><a class="link" class:is-active={section.section_id == params.section_id} href="#/assessment/{params.id}/report/{section.section_id}">{section.section_name}</a></li>
                {/each}
            </ul>
            <p class="menu-label">Report Output</p>
            <ul class="menu-list">
                <li><a class="link" class:is-active={params.section_id == "ppt" || params.slide_no} href="#/assessment/{params.id}/Report/ppt/1">Review PPT</a></li>
                {#if $assessment.assessment_type_data.excel_template}
                <li><a class="link" class:is-active={params.section_id == "excel"} href="#/assessment/{params.id}/Report/excel/">Review Excel</a></li>
                {/if}
            </ul>
        </aside>

        <span></span>
    </div>
    <div class="column">
        {#if params.section_id || params.slide_no}
            {#if params.section_id == "ppt" || params.slide_no}
                <SlideEditor {params} {assessment} {assessment_model}></SlideEditor>
            {:else if params.section_id == "excel"}
                <AssessmentExcelPreview {assessment} {assessment_model}></AssessmentExcelPreview>
            {:else}
                <AssessmentReportSection {assessment} {assessment_model} section_id={params.section_id}></AssessmentReportSection>
            {/if}
        {/if}
    </div>
</div>